import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import LogoContainer from './components/LogoContainer';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <LogoContainer mdxType="LogoContainer" />
    <p><a parentName="p" {...{
        "href": "https://www.npmjs.com/package/react-flexible-sliding-menu"
      }}><img alt="NPM Version Badge" src="https://img.shields.io/npm/v/react-flexible-sliding-menu" /></a>{`
`}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/react-flexible-sliding-menu"
      }}><img alt="NPM Downloads Badge" src="https://img.shields.io/npm/dm/react-flexible-sliding-menu" /></a>{`
`}<a parentName="p" {...{
        "href": "https://bundlephobia.com/result?p=react-flexible-sliding-menu"
      }}><img alt="Minified Size Badge" src="https://img.shields.io/bundlephobia/min/react-flexible-sliding-menu?label=min%20size" /></a>{`
`}<a parentName="p" {...{
        "href": "https://bundlephobia.com/result?p=react-flexible-sliding-menu"
      }}><img alt="Minified Zip Size Badge" src="https://img.shields.io/bundlephobia/minzip/react-flexible-sliding-menu?label=minzip%20size" /></a>{`
`}<a parentName="p" {...{
        "href": "https://github.com/Codebrahma/react-flexible-sliding-menu/blob/master/LICENSE"
      }}><img alt="License Badge" src="https://img.shields.io/npm/l/react-flexible-sliding-menu" /></a>{`
`}<a parentName="p" {...{
        "href": "https://app.netlify.com/sites/react-flexible-sliding-menu/deploys"
      }}><img alt="Netlify(Docs) Build Badge" src="https://img.shields.io/netlify/ec537a2b-5835-41cb-833c-ca62fcc8a436?label=netlify%28docs%29" /></a>{`
`}<a parentName="p" {...{
        "href": "https://github.com/Codebrahma/react-flexible-sliding-menu/stargazers"
      }}><img alt="Github Stars Badge" src="https://img.shields.io/github/stars/Codebrahma/react-flexible-sliding-menu?style=social" /></a>{`
`}<a parentName="p" {...{
        "href": "https://github.com/Codebrahma/react-flexible-sliding-menu/watchers"
      }}><img alt="Github Watchers Badge" src="https://img.shields.io/github/watchers/Codebrahma/react-flexible-sliding-menu?style=social" /></a></p>
    <h1 {...{
      "id": "react-flexible-sliding-menu"
    }}>{`React Flexible Sliding Menu`}</h1>
    <p>{`A `}<strong parentName="p">{`React`}</strong>{` library which provides `}<strong parentName="p">{`Flexible Sliding Menu`}</strong>{` with an easy to use `}<a parentName="p" {...{
        "href": "#"
      }}>{`API`}</a>{` and a bunch of other awesome `}<a parentName="p" {...{
        "href": "/src-docs-introduction#features"
      }}>{`features`}</a>{`. Also, you get to choose which `}<a parentName="p" {...{
        "href": "#"
      }}>{`animation`}</a>{` you want for the sliding menu.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` The library is not restricted to just menus, technically you can provide any React Component to make it slide.`}</p>
    </blockquote>
    <h2 {...{
      "id": "features"
    }}>{`Features`}</h2>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Fully Flexible:`}</strong>{` Pass whatever component you want, to make it slide and attach the triggers to whatever component you want.`}</li>
      <li parentName="ol"><strong parentName="li">{`Conditionally Rendered:`}</strong>{` Rather than hiding the menu (`}<em parentName="li">{`setting `}<inlineCode parentName="em">{`opacity:0`}</inlineCode>{`, or sending it off the viewport`}</em>{`), it is removed from the DOM itself.`}</li>
      <li parentName="ol"><strong parentName="li">{`Fully Managed State:`}</strong>{` Unlike most other libraries, state of Menu is managed by the library so that you don't have to.`}</li>
      <li parentName="ol"><strong parentName="li">{`Uses React Context:`}</strong>{` several methods are provided via context, so you can access it wherever you want in the component tree.`}</li>
    </ol>
    <h2 {...{
      "id": "motivation"
    }}>{`Motivation`}</h2>
    <p>{`There are a lot of libraries out there which set out to do the same thing, some accomplished it some don't. But, I always found one or another thing missing in them. Hence, I built this library to fulfill my needs and possibly yours.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      